import React, {Component} from 'react';
import styles from './NotificationListItem.module.css';
import DefaultProfileImg from '../../../../shared/project-info/images/DefaultProfileImg.png';
import {howLongAgo} from '../../../../shared/utils/Helpers';
import {withRouter} from 'react-router-dom';
import Loading from '../Loading';
import {userProfile} from '../../../../shared/models/UserProfile';
import {logAccessNotification} from '../../../../shared/models/Analytics';

class NotificationListItem extends Component {
  constructor(props) {
    super(props);

    const data = props.item.activities[0];
    this.state = {
      data,
      photoClickable: data.actor
        ? !data.actor.anonymous_profile
        : !data?.user?.anonymous_profile,
      photoClickId: data?.object ? data?.actor.id : data?.user?.id,
      isFollowing: data?.is_following || null,
    };

    this.currentUser = userProfile.getUserProfile();
  }

  renderProfilePhoto = (data) => data?.actor?.profile_photo_url;

  renderActorName = (data) => {
    if (
      data.verb === 'follow' ||
      data.verb === 'update' ||
      data.verb === 'cancel' ||
      data.verb === 'post' ||
      data.verb === 'like' ||
      data.verb === 'comment' ||
      data.verb === 'create'
    )
      return `${data.actor?.first_name} ${data.actor?.last_name}`;
  };

  renderAction = (data) => {
    if (data.verb === 'follow') return 'started following you';
    else if (data.verb === 'update' || data.verb === 'cancel')
      return `${data.verb === 'update' ? 'updated' : 'canceled'} the event`;
    else if (data.verb === 'like' || data.verb === 'comment')
      return `${data.verb === 'like' ? 'liked' : 'commented on'} your post`;
    else if (data.verb === 'create') {
      const type = data.comment_id ? 'comment' : 'post';
      let taggedCurrentUser = false;
      for (let i = 0; i < data.tagged.length; i++) {
        if (data.tagged[i].id == this.currentUser.id) {
          taggedCurrentUser = true;
          break;
        }
      }
      let mentionText;
      if (data?.event?.id && !taggedCurrentUser) return 'posted on your event';
      else if (data?.event?.id && taggedCurrentUser)
        mentionText = 'on an event';
      else if (data?.group?.id) mentionText = 'in a group';
      else mentionText = `in a ${type}`;
      return `mentioned you ${mentionText}`;
    }
  };

  renderSpecificText = (data) => {
    if (
      data.verb === 'update' ||
      data.verb === 'cancel' ||
      data.verb === 'post'
    )
      return data.object.name;
    else return '';
  };

  userProfileClickHandler = () => {
    const {photoClickable, photoClickId} = this.state;
    if (photoClickable && photoClickId) {
      this.props.history.push(`/profile/${photoClickId}`);
    } else {
      alert('This user has set their profile to anonymous.');
    }
  };

  notificationClickHandler = () => {
    const {data} = this.state;
    const {history} = this.props;
    logAccessNotification();
    if (data.verb === 'follow') {
      this.userProfileClickHandler();
    }
    // both update and cancel navigate to an event
    else if (data.verb === 'update' || data.verb === 'cancel') {
      history.push(`/events/${data.object.id}`);
    } else if (
      data.verb === 'like' ||
      data.verb === 'comment' ||
      data.verb === 'replied'
    ) {
      const streamID = data.object.split(':')[1];
      history.push({
        pathname: `/feed/${streamID}`,
        state: {
          poster: this.currentUser,
          time: data.time,
          streamID,
          postID: data.id,
          previousScreen: 'notifications',
        },
      });
    } else if (data.verb === 'create') {
      if (data.object.id) {
        history.push(`/events/${data.object.id}`);
      } else {
        const streamID = data.id;
        history.push({
          pathname: `/feed/${streamID}`,
          state: {
            poster: data.comment_id ? {id: data.author_id} : data.actor,
            time: data.time,
            streamID,
            postID: data.id,
            previousScreen: 'notifications',
            commentID: data.comment_id,
          },
        });
      }
    } else if (data.verb === 'post') {
      const streamID = data.post_id;
      history.push({
        pathname: `/feed/${streamID}`,
        state: {
          poster: data.user,
          time: data.time,
          streamID,
          postID: data.id,
          previousScreen: 'notifications',
        },
      });
    }
  };

  render() {
    const {data, isFollowing} = this.state;
    return (
      <div className={styles.container} onClick={this.notificationClickHandler}>
        <div
          className={styles.userImageContainer}
          onClick={(e) => {
            e.stopPropagation();
            this.userProfileClickHandler();
          }}>
          <img
            className={styles.profileImage}
            src={this.renderProfilePhoto(data) || DefaultProfileImg}
            alt="User Profile Image"
          />
        </div>
        <p className={styles.textContainer}>
          <span
            className="namesAndObjects"
            onClick={(e) => {
              e.stopPropagation();
              this.userProfileClickHandler();
            }}>
            {this.renderActorName(data)}&nbsp;
          </span>
          {this.renderAction(data)}&nbsp;
          <span className="namesAndObjects">
            {this.renderSpecificText(data)}&nbsp;
          </span>
          • {howLongAgo(data.time)}
        </p>
        {data.verb === 'follow' && !data.actor.anonymous_profile && (
          <div
            className={`${styles.followContainer} ${
              !isFollowing && styles.unFollowContainer
            }`}
            onClick={(e) => {
              e.stopPropagation();
              this.props.updateFollowingStatus(data.actor.id, isFollowing);
            }}>
            <p>{isFollowing ? 'Unfollow' : 'Follow'}</p>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(NotificationListItem);
